import React from 'react';
import { DefaultRole } from 'app/area/administration/shared/types';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { PromptConfirmationModal, withDropdownMenu } from 'ui';
import { DropdownMenuContext } from 'ui/common/dropdown-menu/types';
import { SearchTranslation } from 'app/area/administration/list/constants';

export const DefaultRoleMeatballItem = withDropdownMenu((props: DropdownMenuContext
  & {
    onClick: () => void; label: string; defaultRole?: DefaultRole; translation?: SearchTranslation;
    roleName: string;
  }) => {

  const { label, defaultRole, translation, onClick, handleDropdownHide, roleName } = props;

  const onClickHandler = () => {
    handleDropdownHide();
    onClick();
  };

  const saveButton = <button type="button" className="dropdown-item" onClick={onClickHandler}>
    {label}
  </button>;

  const hasDefaultRole = !!defaultRole?.value;

  return <li>
    {hasDefaultRole ? <PromptConfirmationModal
      title={translation.default_role_title}
      description={replaceTemplateString(translation.default_role_description, defaultRole?.description, roleName)}
      continueText={translation.save}
      cancelText={translation.cancel}
      onContinue={onClickHandler}>
      {saveButton}
    </PromptConfirmationModal> : saveButton}
  </li>;
});
